<template>
  <v-dialog v-model="model" fullscreen transition="dialog-bottom-transition" persistent>
    <v-card class="food-details-dialog">
      <v-sheet class="food-details-header" height="260" tile>
        <v-img
          v-if="imageSrc"
          :src="imageSrc"
          height="260"
          class="food-details-img"
          cover
        />
        <v-sheet
          v-else
          color="grey lighten-4"
          height="260"
          class="d-flex align-center justify-center food-details-img"
        >
          <v-icon size="96" color="rgba(0, 0, 0, 0.26)">mdi-food</v-icon>
        </v-sheet>
        <v-btn icon class="close-btn" @click="close">
          <v-icon color="#333" size="32">mdi-close</v-icon>
        </v-btn>
        <v-icon v-if="locked" size="32" color="rgba(0, 0, 0, 0.26)" class="lock-icon">
          mdi-lock
        </v-icon>
      </v-sheet>
      <v-card-text class="food-details-content">
        <div class="food-details-date">
          <span class="font-weight-bold">{{ dayName }}</span>
          <span class="mx-2">|</span>
          <span>{{ dateFormatted }}</span>
        </div>
        <div class="food-details-shift mb-2">{{ shiftLabel }}</div>
        <div class="food-details-title text-h5 font-weight-bold mb-2">
          {{ foodName }}
        </div>
        <div class="food-details-desc mb-4 text-body-1" v-if="food.description">
          {{ food.description }}
        </div>
        <div class="food-details-desc mb-4 text-caption" v-if="food.note">
          {{ food.note }}
        </div>
      </v-card-text>
      <v-card-actions class="food-details-actions">
        <primary-button block height="56" :disabled="locked" @click="addToOrder">
          <v-icon class="mr-2">mdi-cart-plus</v-icon>
          <span>
            {{ isSelected ? $t("remove_from_order") : $t("add_to_order") }}
          </span>
        </primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import conf from "@/config";
import hasModel from "@/mixins/hasModel";

export default {
  mixins: [hasModel],
  props: {
    food: {
      type: Object,
      required: true,
    },
    date: String,
    shiftLabel: String,
    locked: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quantity: 1,
      conf,
    };
  },
  computed: {
    imageSrc() {
      const img = this.food && this.food.image;
      if (img && img.restaurant_id && img.name) {
        return (
          this.conf.apiUrlBase + "/gallery/" + img.restaurant_id + "/medium/" + img.name
        );
      }
      return null;
    },
    foodName() {
      return this.food?.name || "";
    },
    foodDescription() {
      return (
        this.food?.note ||
        this.$t("pages.category_menu.no_description") ||
        "Ovde ide opis jela ako je unesen"
      );
    },
    dayName() {
      if (!this.date) return "";
      const day = moment(this.date).format("dddd");
      return this.$t?.(`calendar.${day.toLowerCase()}`) || day;
    },
    dateFormatted() {
      if (!this.date) return "";
      return moment(this.date).format("DD.MM.YYYY.");
    },
  },
  methods: {
    close() {
      this.model = false;
    },
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity > 1) this.quantity--;
    },
    addToOrder() {
      this.$emit("onFoodToggled");
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

// Dialog container
.food-details-dialog {
  background: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
}

// Header section
.food-details-header {
  position: relative;
  width: 100%;
  min-height: 260px;
  background: rgba(0, 0, 0, 0.04);
  overflow: hidden;
  z-index: 1;
}

.food-details-img {
  object-fit: cover;
}

// Close button
.close-btn {
  position: absolute !important;
  top: 16px;
  left: 16px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.85) !important;
}

// Lock icon
.lock-icon {
  position: absolute;
  bottom: 16px;
  left: 16px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  z-index: 2;
  padding: 2px;
}

// Content section
.food-details-content {
  padding: 32px 24px 0 24px !important;
  border-radius: 16px 16px 0 0;
  position: relative;
  bottom: 16px;
  background-color: white;
  z-index: 55;
}

// Date display
.food-details-date {
  font-size: 1.1rem;
  color: $primary-color;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

// Shift label
.food-details-shift {
  color: rgba(0, 0, 0, 0.54);
  font-size: 1rem;
}

// Title
.food-details-title {
  color: rgba(0, 0, 0, 0.9);
  letter-spacing: 0.01em;
}

// Description
.food-details-desc {
  color: rgba(0, 0, 0, 0.6);
  font-size: 1.1rem;
  min-height: 32px;
}

// Actions section
.food-details-actions {
  padding: 0 24px 32px 24px !important;
  margin-top: auto;
}

// Quantity buttons
.btn-qty {
  background: #fff !important;
  border-radius: 12px !important;
  border: 1px solid #eee !important;
  min-width: 48px;
  height: 48px;
  box-shadow: none !important;
}

.btn-qty-minus {
  background: rgba($error-color, 0.1) !important;
}

.btn-qty-plus {
  background: rgba($success-color, 0.1) !important;
}
</style>
